export * from "./dataset-v2.js";
export const SIMULATION_EXECUTIVE_ROLES = [
    { value: "CEO", label: "CEO / Chief Executive Officer" },
    { value: "CFO", label: "CFO / Chief Financial Officer" },
    { value: "COO", label: "COO / Chief Operating Officer" },
    { value: "CTO", label: "CTO / Chief Technology Officer" },
    { value: "CIO", label: "CIO / Chief Information Officer" },
    { value: "CMO", label: "CMO / Chief Marketing or Medical Officer" },
    { value: "CLO", label: "CLO / Chief Legal Officer / General Counsel" },
    { value: "PRESIDENT", label: "President" },
];
export const MAX_SIMULATION_THESES = 5;
export function simulationTheses(configuration) {
    return configuration.theses ?? [{ id: "single", name: "Thesis 1",
            configuration: { policies: configuration.policies, portfolio: configuration.portfolio } }];
}
